import Login from "../components/Login";
import Home from "../components/Home";
import SendCoupon from "../components/SendCoupon";
import YourCoupons from "../components/YourCoupons";
import Profile from "../components/Profile";
import RequestAccess from "../components/RequestAccess";
import Admin from "../components/Admin";

import withAuth from "../auth.js";

const routes = [
  { path: "/", name: "home", component: withAuth(Home, false) },
  { path: "/new", component: withAuth(SendCoupon) },
  { path: "/your", component: withAuth(YourCoupons) },
  { path: "/admin", component: withAuth(Admin) },
  { path: "/login", name: "login", component: Login },
  { path: "/profile", name: "profile", component: withAuth(Profile) },
  { path: "/reqaccess", name: "request_access", component: withAuth(RequestAccess, false) }
];

export default routes;
